import React, {useMemo, useState} from 'react';
import {Table, Popup, Icon} from 'semantic-ui-react';
import {useTable, usePagination, useFilters, useRowSelect} from 'react-table';
import {
  Filter,
  DefaultColumnFilter,
} from '../../../common/components/tableFilters/index';
import TechnicianGroupForm from './TechnicianGroupForm';
import TablePaginator from '../../../common/components/reactTablePagination';

const columnsTableWithProps = (
  type,
  setEditRow,
  setCurrentForm,
  cancelAddInfo,
  columnsInfo,
) => {
  return columnsInfo.concat([
    {
      'id': 'actions',
      'Header': 'ACCIONES',
      'Cell': ({row}) => {
        let updateValue = {'status': row.original.status[0]};
        if (type === 'groupTechnician') {
          updateValue = {...updateValue, 'area': row.original.primaryCode};
        } else {
          updateValue = {...updateValue, ...row.original};
        }
        return (
          <Popup
            trigger={
              <Icon
                name="write"
                color="red"
                size="large"
                onClick={() => {
                  cancelAddInfo();
                  setEditRow(row.index);
                  setCurrentForm({...row.values, ...updateValue});
                }}
              />
            }
            content="Editar"
            position="top center"
            inverted
          />
        );
      },
    },
  ]);
};

const TechniciansTable = (props) => {
  const {
    list,
    addInfo,
    cancelAddInfo,
    loadingDetail,
    optionsList,
    technicalGroupList,
    columnsInfo,
    type,
  } = props;
  const [editRow, setEditRow] = useState('');
  const [currentForm, setCurrentForm] = useState({});
  const columnsTable = columnsTableWithProps(
    type,
    setEditRow,
    setCurrentForm,
    cancelAddInfo,
    columnsInfo,
  );
  
  const data = useMemo(() => list, [list]);
  const columns = useMemo(() => columnsTable, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    'state': {pageIndex, pageSize},
  } = useTable(
    {
      columns,
      data,
      'defaultColumn': {'Filter': DefaultColumnFilter},
      'initialState': {'pageIndex': 0, 'pageSize': 10},
      'autoResetFilters': false,
    },
    useFilters,
    usePagination,
    useRowSelect
  );

  return (
    <>
      <div className="table-container">
        <Table className="interactive" striped compact {...getTableProps()}>
          <Table.Header>
            {headerGroups.map((headerGroup) => (
              <>
                <Table.Row key="headers" {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column, index) => (
                    <Table.HeaderCell
                      key={`title-${index}`}
                      textAlign="center"
                      {...column.getHeaderProps()}
                    >
                      {column.render('Header')}
                    </Table.HeaderCell>
                  ))}
                </Table.Row>
                <Table.Row key="filters" id="filters">
                  {headerGroup.headers.map((column, index) => (
                    <Table.HeaderCell
                      key={`filter-${index}`}
                      textAlign="center"
                    >
                      <Filter column={column} />
                    </Table.HeaderCell>
                  ))}
                </Table.Row>
                {addInfo && (
                  <Table.Row key="new-row" className="new-register">
                    {headerGroup.headers.map((column, index) => (
                      <Table.HeaderCell
                        key={`new-area-${index}`}
                        textAlign="center"
                      >
                        <TechnicianGroupForm
                          id={column.id}
                          type={type}
                          currentForm={currentForm}
                          setCurrentForm={setCurrentForm}
                          cancelAddInfo={cancelAddInfo}
                          setEditRow={setEditRow}
                          addInfo={addInfo}
                          optionsList={optionsList}
                          technicalGroupList={technicalGroupList}
                        />
                      </Table.HeaderCell>
                    ))}
                  </Table.Row>
                )}
              </>
            ))}
          </Table.Header>
          <Table.Body {...getTableBodyProps()}>
            {!page.length && (
              <Table.Row>
                <Table.Cell colSpan={15} textAlign="center">
                  No hay datos disponibles
                </Table.Cell>
              </Table.Row>
            )}
            {page.length > 0 &&
              page.map((row, i) => {
                prepareRow(row);
                return (
                  <Table.Row key={i}>
                    {row.cells.map((cell, idx) => {
                      if (editRow === i) {
                        return (
                          <Table.Cell
                            textAlign="center"
                            key={idx}
                            {...cell.getCellProps()}
                          >
                            <TechnicianGroupForm
                              id={cell.column.id}
                              type={type}
                              currentForm={currentForm}
                              setCurrentForm={setCurrentForm}
                              cancelAddInfo={cancelAddInfo}
                              setEditRow={setEditRow}
                              addInfo={addInfo}
                              loadingDetail={loadingDetail}
                              optionsList={optionsList}
                              technicalGroupList={technicalGroupList}
                            />
                          </Table.Cell>
                        );
                      }
                      return (
                        <Table.Cell
                          key={idx}
                          textAlign="center"
                          {...cell.getCellProps()}
                        >
                          {cell.render('Cell')}
                        </Table.Cell>
                      );
                    })}
                  </Table.Row>
                );
              })}
          </Table.Body>
        </Table>
      </div>
      <TablePaginator
        data={data}
        canPreviousPage={canPreviousPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        pageSize={pageSize}
        canNextPage={canNextPage}
        nextPage={nextPage}
        gotoPage={gotoPage}
        previousPage={previousPage}
        setPageSize={setPageSize}
      />
    </>
  );
};

export default TechniciansTable;
